"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonContactsService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class PersonContactsService {
    /**
     * Adds a contact to a person.
     * Requires the authenticated user to be a primary contact of the personId, and have the necessary capabilities.
     * If the contact to add in the request is a V2 user, will add the contact to the person.
     * If the contact is not a V2 user, it will create a new V2 user (or update from V1) and then add the contact to the person.
     * @param personId The person ID of the person to add the contact to.
     * @param requestBody The request body containing the contact details to add.
     * @returns ContactResponse Success
     * @throws ApiError
     */
    static createContact(personId, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v2/persons/{personId}/contacts',
            path: {
                'personId': personId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates a contact's role for a person.
     * Requires the calling user to be authenticated and have the necessary capabilities.
     * Requires the provided contactUserId to be contact of the personId.
     * @param personId The person ID of the person to update the contact for.
     * @param contactUserId The user ID of the contact to update.
     * @param requestBody The request body containing the contact details to update.
     * @returns ContactResponse Success
     * @throws ApiError
     */
    static updateContact(personId, contactUserId, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PATCH',
            url: '/v2/persons/{personId}/contacts/{contactUserId}',
            path: {
                'personId': personId,
                'contactUserId': contactUserId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Removes a contact from a person.
     * Requires the calling user to be authenticated and have the necessary capabilities.
     * Requires the provided contactUserId to be contact of the personId.
     * @param personId The person ID of the person to remove the contact from.
     * @param contactUserId The user ID of the contact to remove.
     * @returns void
     * @throws ApiError
     */
    static removeContact(personId, contactUserId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'DELETE',
            url: '/v2/persons/{personId}/contacts/{contactUserId}',
            path: {
                'personId': personId,
                'contactUserId': contactUserId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
            },
        });
    }
}
exports.PersonContactsService = PersonContactsService;
